export default {
  tab: {
    contribution: 'Contribution',
    foreign: 'Foreign',
    proprietary: 'Proprietary',
  },
  tooltipMatched: 'Matched: ',
  noData: 'No data available.',
  noDataSell: 'Sell --',
  noDataBuy: 'Buy --',
  tooltipDate: 'The data is calculated from %{from} to %{to}',
  tooltipToday: 'The data is caculated as of %{from}',
};
